import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import Dialog from '../../DesignSystem/Dialog';
import { Post } from '../../../Utils/Types/Posts';
import { editPostPath } from '../../../Utils/routes';
import useSpace from '../../../Hooks/useSpace';

interface ModerationWarningModalProps {
  post: Post;
  open: boolean;
  handleClose: () => void;
  isEdit: boolean;
  onClose?: () => void;
}

function ModerationWarningModal({
  open,
  post,
  isEdit,
  handleClose,
  onClose,
}: ModerationWarningModalProps) {
  const intl = useIntl();
  const { space } = useSpace();

  const editPath = editPostPath(space.slug, post.slug, post.type);

  return (
    <Dialog
      id="post-moderation"
      label={intl.formatMessage({ id: 'MODERATION.MODAL.TITLE' })}
      open={open}
      title={<FormattedMessage id="MODERATION.MODAL.TITLE" />}
      maxWidth="sm"
      onClose={handleClose}
      dismissible={false}
      disableGutters
      fullWidth
      actions={
        <>
          {isEdit ? (
            <Button variant="contained" color="primary" onClick={onClose}>
              <FormattedMessage id="BUTTONS.UPDATE" />
            </Button>
          ) : (
            <Button variant="contained" color="primary" to={editPath} component={Link}>
              <FormattedMessage id="BUTTONS.UPDATE" />
            </Button>
          )}

          <Button variant="outlined" color="primary" onClick={handleClose}>
            <FormattedMessage id="MODERATION.MODAL.SUBMIT" />
          </Button>
        </>
      }
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ mb: 2, fontWeight: 'bold' }}>
          <FormattedMessage id="MODERATION.MODAL.REASON" /> {post.meta.ai_data.moderation_reason}
        </Box>
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1">
            <FormattedMessage id="MODERATION.MODAL.DESCRIPTION" />
          </Typography>
        </Box>
      </Box>
    </Dialog>
  );
}

export default ModerationWarningModal;
